import type { TOC } from '@ember/component/template-only';

interface PrismCardCardTitleSignature {
  Args: {
    isDisabled?: boolean;
    isSecondary?: boolean;
    text?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLHeadingElement;
}

const PrismCardCardTitle = <template>
  {{#if @isSecondary}}
    <h4
      class="prism-card-title {{if @isDisabled 'prism-card-title--disabled'}}"
      ...attributes
    >
      {{yield}}
    </h4>
  {{else}}
    <h3
      class="prism-card-title {{if @isDisabled 'prism-card-title--disabled'}}"
      ...attributes
    >
      {{yield}}
    </h3>
  {{/if}}
</template> satisfies TOC<PrismCardCardTitleSignature>;

export default PrismCardCardTitle;
